import { STATE_GAME, STATE_WELCOME } from 'app/constants/AppConstants';

class AspectController {
  constructor({ game }) {
    this.game = game;
    this.rotateScreenDisabled = false;
  }

  disableRotateScreen() {
    console.log('AspectController.disableRotateScreen');
    this.rotateScreenDisabled = true;
    if (this.game.hud.hudRotateScreen) {
      this.game.hud.closeRotateScreen();
    }
  }

  updateGameSize() {
    if (this.game.scale) {
      let aspect = window.innerWidth / window.innerHeight;
      let maxAspect = 7 / 3;
      let minAspect = 4 / 3;
      if (!this.rotateScreenDisabled) {
        if (window.innerWidth < window.innerHeight) {
          this.displayRotateScreen();
        } else {
          if (this.game.hud.hudRotateScreen) {
            this.game.hud.closeRotateScreen();
          }

          aspect = Math.min(maxAspect, Math.max(minAspect, aspect));
        }
      }

      const targetWidth = Math.min(this.game.defaultHeight * aspect);
      this.game.scale.setGameSize(targetWidth, this.game.defaultHeight);
      // this.game.scale.setUserScale(window.innerHeight / this.game.defaultHeight);
      this.game.scale.setUserScale(1 / aspect);
    }
  }

  displayRotateScreen() {
    if (this.game.state.current === STATE_GAME || this.game.state.current === STATE_WELCOME) {
      this.game.controller.pauseGame();
    }

    this.game.hud.showRotateScreen();
    this.game.world.bringToTop(this.game.hud.hudRotateScreen);
  }
}
export default AspectController;
